module.exports = __webpack_public_path__ + "static/media/hamilton-robson.bf3a18b8.jpg";